import IconArrowShort from '@/components/Icons/IconArrowShort.vue'

export default class ColumnModel {
    constructor (title, innerColumnsCount, showSeats, tickets = [], showPaginator = false, style = {}, arrow = IconArrowShort) {
        this.title = title
        this.innerColumnsCount = innerColumnsCount
        this.showSeats = showSeats
        this.tickets = tickets
        this.showPaginator = showPaginator
        this.style = style
        this.arrow = arrow
    }
}
